import { Injectable } from '@angular/core';
import { ExcelDownloadService } from '../shared/services/excel-download.service';

@Injectable({
  providedIn: 'root',
})
export class AccountOverviewService {
  constructor(public readonly excelService: ExcelDownloadService) {}

  public downloadXls(data, name, filenameNoChange = true) {
    this.excelService.exportAsExcelFile(data, name, filenameNoChange);
  }
}
